__webpack_require__.p = "/blackjack_sim/";